import { render, staticRenderFns } from "./StartButton.vue?vue&type=template&id=44895b23&scoped=true&"
import script from "./StartButton.vue?vue&type=script&lang=js&"
export * from "./StartButton.vue?vue&type=script&lang=js&"
import style0 from "./StartButton.vue?vue&type=style&index=0&id=44895b23&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../.config/yarn/global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44895b23",
  null
  
)

export default component.exports